import React from 'react';
import { SEOHead } from '../common/SEOHead';
import Header from '../layout/Header';
import Footer from '../layout/Footer';
import { useTranslation } from '../../hooks/useTranslation';

interface AuthLayoutProps {
  children: React.ReactNode;
  titleKey: string;
  isModal?: boolean;
  onClose?: () => void;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ 
  children, 
  titleKey, 
  isModal, 
  onClose 
}) => {
  const { t } = useTranslation();

  return (
    <>
      {!isModal && <Header />}
      <div className={isModal ? '' : 'min-h-screen bg-[var(--bg-primary)] flex flex-col'}>
        <SEOHead titleKey={t(titleKey)} descriptionKey={t('features.subtitle')} />
        <div className={isModal ? '' : 'flex-grow flex items-center justify-center px-4'}>
          <div className="max-w-md w-full space-y-6 p-6 rounded-xl border border-[var(--brand-primary)]/20 bg-[var(--bg-primary)]/40">
            {children}
          </div>
        </div>
      </div>
      {!isModal && <Footer />}
    </>
  );
};

export default AuthLayout; 